import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MapPin } from "lucide-react";

export default function CommunityOutreach() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/partners").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-6 py-10" data-testid="community-page">
      <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900">Community Outreach</h1>
      <p className="text-slate-600 mt-2 max-w-2xl">We partner with ABA therapy centers, schools, hospitals, clinics, WIC offices, county offices, and autism sports programs to expand access for families everywhere.</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
        {items.map((p) => (
          <div key={p.id} data-testid={`partner-${p.id}`} className="card-soft p-5">
            <div className="text-xs uppercase tracking-wider text-purple-600 font-bold">{p.type}</div>
            <h3 className="font-display font-bold text-lg mt-1">{p.name}</h3>
            <div className="text-sm text-slate-500 mt-1 inline-flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{p.location}</div>
            <p className="text-sm text-slate-700 mt-2">{p.blurb}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
